var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustoms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M18 7.8h-3.2c-.6 0-1.2-.5-1.2-1.2V4c0-.2.1-.4.2-.5s.3-.2.5-.2c.4 0 .8.1 1 .4L18 6q.6.45.6 1.2c0 .2-.1.4-.2.5s-.2.1-.4.1m-3.4-3.5v2.3c0 .1.1.2.2.2h2.8l-.1-.1-2.7-2.3c-.1 0-.1-.1-.2-.1m-.2 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M16.9 22.8H5.7c-1.1 0-2-.9-2-2V5.2c0-1.1.9-2 2-2h6.5v4.2c0 .9.7 1.6 1.6 1.6h4.9v1.7c0 .3-.2.5-.5.5s-.5-.2-.5-.5V10h-3.9c-1.4 0-2.6-1.2-2.6-2.6V4.2H5.7c-.5 0-1 .4-1 1v15.5c0 .5.4 1 1 1h11.2c.4 0 .8-.3.8-.8v-4.5c0-.3.2-.5.5-.5s.5.2.5.5V21c0 1-.8 1.8-1.8 1.8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M21.6 10.2c-.2-.2-.5-.2-.8 0l-.4.4c-.1.1-.1.3 0 .4l.4.4c.1.1.3.1.4 0l.4-.4c.2-.3.2-.6 0-.8m-2 1.2-6 6-.1.1-.3.8c0 .1 0 .1.1.2h.1l.8-.3s.1 0 .1-.1l6-6c.1-.1.1-.3 0-.4l-.3-.3c-.1-.1-.3-.1-.4 0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.5 11.9h1.1v1H6.5z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M8.4 11.9h2.3v1H8.4zM8.4 14.3h3.7v1H8.4z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.5 14.3h1.1v1H6.5z"
})));
export default SvgCustoms;